import { render } from "./TextEditor.vue?vue&type=template&id=601800cd&scoped=true"
import script from "./TextEditor.vue?vue&type=script&lang=js"
export * from "./TextEditor.vue?vue&type=script&lang=js"

import "./TextEditor.vue?vue&type=style&index=0&id=601800cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601800cd"]])

export default __exports__